import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class StatusVooConfiguracaoService {
  private baseUrl = environment.baseUrl
  private resource = 'StatusVoo/configuracao'

  constructor(private httpClient: HttpClient) {}

  getConfiguracao(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}`)
  }

  saveConfiguracao(model: {
    intervaloAtualizacaoMinutos: number
    ativo: boolean
  }): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}`, model)
  }
}
